export default function LogoutIcon() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 11.6667L16.4596 10.7071C16.8501 10.3166 16.8501 9.68344 16.4596 9.29291L15.5 8.33335"
        stroke="#E9EFF7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3335 10L11.3335 10M3.8335 14.3886V6.05527M13.8335 14.3886C13.8335 15.3091 13.0873 16.0553 12.1668 16.0553H8.8335M13.8335 6.05527C13.8335 5.1348 13.0873 4.38861 12.1668 4.38861H8.8335M4.57566 16.5501L6.24233 17.6612C7.34992 18.3996 8.8335 17.6056 8.8335 16.2744V4.16947C8.8335 2.83831 7.34992 2.04432 6.24233 2.78272L4.57566 3.89383C4.112 4.20294 3.8335 4.72333 3.8335 5.28058V15.1633C3.8335 15.7206 4.112 16.2409 4.57566 16.5501Z"
        stroke="#E9EFF7"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
